import {
    useSlotPluginDescriptors as useSlotPluginDescriptorsFromHost,
    type SlotPluginDescriptor,
} from '@yandex-360/360-plugin-host';

import { getSlotPluginsConfigUrl } from './fetch-slot-plugins-config';

interface TelemostUseSlotPluginDescriptorsResult {
    plugins: SlotPluginDescriptor[];
    loading: boolean;
}

export function useSlotPluginDescriptors(
    slot: string,
    enabled: boolean,
    configUrl?: string | null
): TelemostUseSlotPluginDescriptorsResult {
    return useSlotPluginDescriptorsFromHost(slot, {
        enabled,
        configUrl: getSlotPluginsConfigUrl(enabled, configUrl),
    });
}
